import script from "./StoreCover.vue?vue&type=script&setup=true&lang=ts"
export * from "./StoreCover.vue?vue&type=script&setup=true&lang=ts"

import "./StoreCover.vue?vue&type=style&index=0&id=5a382414&lang=css"

const __exports__ = script;

export default __exports__